// VIDEO LAZYLOAD
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

$(document).on("click", "[add-to-cart-express]", function (event) {
  event.preventDefault();
  let formData = {
    items: [
      {
        id: parseInt($(this).attr("add-to-cart-express")),
        quantity: 1,
      },
    ],
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      document.dispatchEvent(
        new CustomEvent("cart-update", {
          detail: { ...response, eventName: "add_to_cart" },
        })
      );
      window.updateCart();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});
// UPSELL Carrinho
window.upsellSliderInit = function () {
  var upsellCartSlider = new Swiper(".recommend-slider", {
    slidesPerView: "auto",
    spaceBetween: 15,
    slidesPerGroup: 3,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
  });
};

function beforeSend() {
  $("#dropdown-cart").addClass("updating-cart");
}

function afterSend() {
  $("#dropdown-cart").removeClass("updating-cart");
}

$(document).on("submit", ".upsell-form", function (e) {
  e.preventDefault();

  const formData = new FormData(this);
  const serializedData = {};
  formData.forEach((value, key) => {
    serializedData[key] = value;
  });
  const jsonData = JSON.stringify(serializedData);

  // URL da API da Shopify para adicionar um item ao carrinho
  const addToCartUrl = window.Shopify.routes.root + "cart/add.js";

  // Opções da requisição
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: jsonData,
  };

  beforeSend(); // Ação "before send" antes da requisição

  // Faz a requisição usando fetch com ação "before send" e "after send"
  fetch(addToCartUrl, requestOptions)
    .then((response) => {
      afterSend(); // Ação "after send" após a conclusão da requisição

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui
      document.dispatchEvent(
        new CustomEvent("cart-update", {
          detail: { ...data, eventName: "add_to_cart" },
        })
      );
      window.updateCart();
    })
    .catch((error) => {
      // Houve um erro na requisição, você pode tratar o erro aqui
      console.error("Error:", error);
    });
});

$(document).on("input", "#custom-property", function (e) {
  document.querySelector("#meta_customization").value = e.target.value;
  const btn = document.querySelector("[data-btn-addToCart]");

  if (e.target.value?.length > 0) {
    btn.disabled = false;
  } else {
    btn.disabled = true;
  }
});

/* CORRECAO: seletor de cor do painel fixo (CTA) mobile.
   Defeito do tema Halo: (1) <variant-sticky-radios> nao liga ouvinte de clique;
   (2) o form proprio do painel mobile nunca sincroniza o input[name=id] com a cor,
   entao ia a variante inicial ao carrinho. Correcao idempotente, sem libs. */
(function () {
  function moneyBRL(cents) {
    try {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(cents / 100);
    } catch (e) { return null; }
  }
  function wire(el) {
    if (el.dataset.fixMobileWired === "1") return;
    el.dataset.fixMobileWired = "1";
    var panel = el.closest(".sticky-product-mobile") || el.closest("sticky-add-to-cart") || document;
    var jsonNode = el.querySelector('script[type="application/json"]');
    if (!jsonNode) return;
    var variants;
    try { variants = JSON.parse(jsonNode.textContent); } catch (e) { return; }
    var radios = el.querySelectorAll("input.product-form__radio.mobile");
    if (!radios.length) return;
    function optionNames() {
      var names = [];
      el.querySelectorAll("fieldset[data-option-index]").forEach(function (fs) {
        var idx = parseInt(fs.getAttribute("data-option-index"), 10);
        var checked = fs.querySelector("input.product-form__radio.mobile:checked");
        names[idx] = checked ? checked.value : null;
      });
      return names;
    }
    function findVariant() {
      var selected = optionNames();
      var anyChecked = el.querySelector("input.product-form__radio.mobile:checked");
      if (selected.filter(Boolean).length <= 1 && anyChecked && anyChecked.dataset.variantId) {
        var byId = variants.find(function (v) { return String(v.id) === String(anyChecked.dataset.variantId); });
        if (byId) return byId;
      }
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] == null || selected[i] === opt; });
      });
    }
    function sync() {
      var v = findVariant();
      if (!v) return;
      panel.querySelectorAll('input[name="id"]').forEach(function (inp) { inp.value = v.id; });
      var priceNode = panel.querySelector(".sticky-price .money-subtotal");
      if (priceNode) { var m = moneyBRL(v.price); if (m) priceNode.textContent = m; }
      var cmpWrap = panel.querySelector(".sticky-price");
      var cmpNode = panel.querySelector(".sticky-price .money-compare-price");
      if (cmpNode) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var mc = moneyBRL(v.compare_at_price); if (mc) cmpNode.textContent = mc;
          if (cmpWrap) cmpWrap.classList.add("has-compare-price");
        } else {
          cmpNode.textContent = "";
          if (cmpWrap) cmpWrap.classList.remove("has-compare-price");
        }
      }
      el.querySelectorAll("fieldset[data-option-index]").forEach(function (fs) {
        var checked = fs.querySelector("input.product-form__radio.mobile:checked");
        var header = fs.querySelector("[data-header-option]");
        if (checked && header) header.textContent = checked.value;
      });
    }
    el.addEventListener("change", function (e) {
      if (e.target && e.target.classList && e.target.classList.contains("product-form__radio")) { sync(); }
    });
    el.addEventListener("click", function (e) {
      var lbl = e.target.closest && e.target.closest("label.product-form__label.mobile");
      if (lbl) { setTimeout(sync, 0); }
    });
    sync();
  }
  function init() { document.querySelectorAll("variant-sticky-radios").forEach(wire); }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); } else { init(); }
  document.addEventListener("shopify:section:load", init);
})();
/* CORRECAO: grade das colecoes com o app EX Show Variants (Variator, Extendons).
   Defeito do app: ele insere TODOS os cartoes de variante dentro de UMA unica
   celula da grade, em vez de uma celula por variante. Resultado: os cartoes
   empilham numa coluna so e o resto da linha fica vazio.
   Esta correcao move cada cartao extra para uma celula propria, clonada da
   celula que o proprio tema criou, preservando largura, espacamento e ordem.
   Vale para qualquer colecao, busca, paginacao e rolagem infinita.
   Idempotente, sem libs. Adicionada em 07/08/2026.
   Pode ser removida quando a Extendons corrigir o app. */
(function () {
  function ajustar() {
    var cartoes = document.querySelectorAll(".eosh-rendered");
    if (!cartoes.length) return false;

    var celulas = [];
    for (var i = 0; i < cartoes.length; i++) {
      var pai = cartoes[i].parentElement;
      if (pai && pai.parentElement && celulas.indexOf(pai) === -1) celulas.push(pai);
    }

    var mexeu = false;
    for (var j = 0; j < celulas.length; j++) {
      var celula = celulas[j];
      var dentro = [];
      for (var k = 0; k < celula.children.length; k++) {
        if (celula.children[k].classList.contains("eosh-rendered")) {
          dentro.push(celula.children[k]);
        }
      }
      if (dentro.length < 2) continue;

      var ref = celula;
      for (var m = 1; m < dentro.length; m++) {
        var nova = celula.cloneNode(false);
        nova.setAttribute("data-eosh-celula-extra", "1");
        nova.appendChild(dentro[m]);
        ref.parentElement.insertBefore(nova, ref.nextSibling);
        ref = nova;
        mexeu = true;
      }
    }
    return mexeu;
  }

  var agendado = null;
  function agendar() {
    if (agendado) return;
    agendado = setTimeout(function () {
      agendado = null;
      ajustar();
    }, 120);
  }

  function iniciar() {
    ajustar();
    if (!("MutationObserver" in window)) return;
    new MutationObserver(agendar).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
  document.addEventListener("shopify:section:load", agendar);
})();

// CORRIGE ERRO DO SCRIPT DE TERCEIROS DA EDRONE (mousedown global em document.body):
// o script deles lê input[name="nome"].value antes de checar se o elemento existe,
// e como esse campo não existe em nenhuma página deste tema, todo clique no site
// jogava "Cannot read properties of null" no console. Criamos um input oculto vazio
// só para satisfazer a checagem deles; não altera nenhum comportamento visível.
(function () {
  if (document.querySelector('input[name="nome"]')) return;
  var fakeNomeInput = document.createElement("input");
  fakeNomeInput.type = "hidden";
  fakeNomeInput.name = "nome";
  fakeNomeInput.value = "";
  document.body.appendChild(fakeNomeInput);
})();

// Acessibilidade (navegação agêntica do PageSpeed): dá nome às caixas de
// ordenar avaliações da Konfidency na página de produto.
// O widget da Konfidency cria DUAS select.sort-field (uma escondida e uma
// visível) e nenhuma tem rótulo. A tentativa do PR 62 usava querySelector,
// que rotula só a primeira e para; por isso a visível continuava sem nome.
// Aqui rotulamos TODAS as que ainda não têm aria-label, inclusive as que o
// widget cria depois do carregamento.
(function () {
  if (!document.body || !document.body.classList.contains("template-product")) return;
  if (!("MutationObserver" in window)) return;

  function rotular(raiz) {
    var l = (raiz || document).querySelectorAll("select.sort-field:not([aria-label])");
    for (var i = 0; i < l.length; i++) l[i].setAttribute("aria-label", "Ordenar avaliações");
  }

  var caixa = null;
  var obs = new MutationObserver(function () {
    if (!caixa) {
      caixa = document.getElementById("konfidency-reviews-container");
      if (!caixa) return;
      // Achou a caixa das avaliações: passa a observar só ela, que é mais leve.
      obs.disconnect();
      obs.observe(caixa, { childList: true, subtree: true });
    }
    rotular(caixa);
  });

  rotular(document);
  obs.observe(document.body, { childList: true, subtree: true });
  // Se em 30 segundos a caixa da Konfidency não apareceu, para de observar.
  // 16/10/2026: a Konfidency agora carrega depois do evento load (layout/theme.liquid),
  // então os 30 segundos contam a partir do início do carregamento dela.
  function prazo() {
    setTimeout(function () {
      if (!caixa) obs.disconnect();
    }, 30000);
  }
  if (window.ctKonfidencyInicio || !window.ctCarregaKonfidency) prazo();
  else document.addEventListener("ct:konfidency-carregando", prazo, { once: true });
})();

// Acessibilidade (navegação agêntica do PageSpeed): o slick 1.6 põe
// aria-hidden="true" na bolinha inativa (li da .slick-dots), mas o botão
// dentro dela continua focável. Elemento focável escondido do leitor de tela
// é erro de acessibilidade (aria-hidden-focus), então tiramos esse aria-hidden.
// Provado no carrossel de produtos da home (seção product_block, slider
// products-carousel): antes 1 falha aria-hidden-focus, depois 0, e as
// bolinhas continuam trocando o slide.
(function () {
  if (!window.jQuery) return;

  function limpar(el) {
    jQuery(el || document).find(".slick-dots li[aria-hidden]").removeAttr("aria-hidden");
  }

  jQuery(document).on("init reInit afterChange setPosition", ".slick-slider", function () {
    limpar(this);
  });
  jQuery(window).on("load", function () {
    limpar();
  });
})();

/* TRAVA DA INICIAL (08/10/2026): nos produtos personalizados, o cliente so compra
   depois de digitar a letra. O botao principal nasce travado no Liquid, mas o script
   de variante do tema o reabre (provado no ar em 08/10, campo vazio e COMPRAR liberado).
   Aqui a trava vale para o botao principal e para a barra fixa. A barra fixa nao tem o
   campo da letra no formulario dela; com a letra digitada, o clique nela aciona o botao
   principal, para a letra ir junto no pedido. O "Compre junto" nao entra: ele so adiciona
   os produtos sugeridos, nunca o produto da pagina. */
(function () {
  var MARCA = "data-trava-inicial";
  function campo() { return document.getElementById("custom-property"); }
  function vazio() { var c = campo(); return !!c && !c.value.trim(); }
  function ehCompra(form) { return !!form && /\/cart\/add/.test(form.getAttribute("action") || ""); }
  function botoes() {
    return Array.prototype.filter.call(
      document.querySelectorAll('button[name="add"]'),
      function (b) { return ehCompra(b.form) && !b.closest(".monte-kit__container"); }
    );
  }
  function aviso() {
    var c = campo();
    if (!c) return;
    var m = document.getElementById("aviso-inicial");
    if (!m) {
      m = document.createElement("p");
      m.id = "aviso-inicial";
      m.setAttribute("role", "alert");
      m.style.cssText = "color:#b42318;font-size:13px;line-height:1.4;margin:6px 0 0";
      m.textContent = "Digite a inicial do bordado antes de comprar.";
      c.insertAdjacentElement("afterend", m);
    }
    c.scrollIntoView({ behavior: "smooth", block: "center" });
    try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); }
  }
  function sincroniza() {
    if (!campo()) return;
    var travar = vazio();
    botoes().forEach(function (b) {
      if (travar) {
        if (!b.disabled) { b.disabled = true; b.setAttribute(MARCA, "1"); }
      } else if (b.hasAttribute(MARCA)) {
        b.disabled = false;
        b.removeAttribute(MARCA);
      }
    });
    var m = document.getElementById("aviso-inicial");
    if (m && !travar) m.remove();
  }
  function principal() {
    var h = document.getElementById("meta_customization");
    return h && h.form ? h.form.querySelector('button[name="add"]') : null;
  }
  function barra(e) {
    if (!campo()) return;
    var b = e.type === "submit" ? e.submitter : e.target.closest('button[name="add"]');
    var f = e.type === "submit" ? e.target : b && b.form;
    if (!ehCompra(f) || (b && b.closest(".monte-kit__container"))) return;
    if (vazio()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      aviso();
      return;
    }
    if (!f.querySelector("#meta_customization")) {
      var p = principal();
      e.preventDefault();
      e.stopImmediatePropagation();
      if (p) { p.disabled = false; p.click(); }
    }
  }
  function inicia() {
    if (!campo()) return;
    document.addEventListener("click", barra, true);
    document.addEventListener("submit", barra, true);
    campo().addEventListener("input", function () { setTimeout(sincroniza, 0); });
    new MutationObserver(function () { if (vazio()) sincroniza(); })
      .observe(document.body, { subtree: true, attributes: true, attributeFilter: ["disabled"] });
    sincroniza();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", inicia);
  else inicia();
})();

// Estrelas clicáveis (13/10/2026): a linha "★★★★★ 4,9 · N avaliações" junto do
// título (snippets/product-title.liquid) virou link para as avaliações da
// Konfidency (#konfidency-reviews-container, criada pelo script deles depois do
// carregamento). Aqui descontamos a altura do cabeçalho fixo, levamos o foco do
// teclado junto e, se a caixa ainda não existir, esperamos por ela até 15
// segundos com UMA espera só (cliques repetidos não criam outras).
(function () {
  if (!document.body || !document.body.classList.contains("template-product")) return;

  var espera = null;

  function acharAlvo() {
    return document.getElementById("konfidency-reviews-container");
  }

  function irPara(alvo) {
    var topo = 0;
    var cab = document.querySelector(".shopify-section-group-header-group");
    if (cab) {
      var pos = getComputedStyle(cab).position;
      var r = cab.getBoundingClientRect();
      if ((pos === "sticky" || pos === "fixed") && r.bottom > 0) topo = r.bottom;
    }
    var y = alvo.getBoundingClientRect().top + window.pageYOffset - topo - 12;
    var suave = !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    window.scrollTo({ top: Math.max(0, y), behavior: suave ? "smooth" : "auto" });
    if (!alvo.hasAttribute("tabindex")) alvo.setAttribute("tabindex", "-1");
    try {
      alvo.focus({ preventScroll: true });
    } catch (err) {}
  }

  document.addEventListener("click", function (e) {
    var link = e.target && e.target.closest ? e.target.closest("a.ct-estrelas-link") : null;
    if (!link) return;
    e.preventDefault();
    var alvo = acharAlvo();
    if (alvo) {
      if (espera) {
        clearInterval(espera);
        espera = null;
      }
      irPara(alvo);
      return;
    }
    if (espera) return;
    var inicio = Date.now();
    espera = setInterval(function () {
      var achou = acharAlvo();
      // 16/10/2026: os 15 s contam a partir do início do carregamento da Konfidency
      // (que agora começa depois do evento load, ou no próprio clique).
      var base = Math.max(inicio, window.ctKonfidencyInicio || 0);
      if (achou || Date.now() - base > 15000) {
        clearInterval(espera);
        espera = null;
        if (achou) irPara(achou);
      }
    }, 200);
  });
})();

// TBT (17/10/2026): cliques falsos do app Stamp nos cartões da coleção.
// Ao abrir a coleção, o Stamp dá um clique de mentira (não é toque do cliente,
// event.isTrusted = false) em cada cartão, na bolinha de cor escondida dentro
// da janela de compra rápida (.card .variants-popup-content .swatch-element).
// Nada no tema responde a esse clique (conferido: os 64 cartões ficam iguais com
// e sem ele: link, fotos, preço, título, cor marcada, variante), mas ele subia
// até o document e passava, ~59 vezes, por ~45 ouvintes de clique do tema.
// Medido no Chrome de teste com o processador 4x mais lento: tempo travado da
// coleção 4.751 -> 4.230 ms (mediana de 6 + 6).
// Aqui esse clique para no próprio cartão: quem escuta na bolinha ou dentro do
// cartão continua recebendo; na volta (fase de bolha) ele não sobe mais para
// body, document e window. Quem escuta na ida (fase de captura) nesses lugares
// continua recebendo, como antes.
// Clique de verdade (toque do cliente) e clique que o tema dá na etiqueta
// (.single-label) não passam por aqui.
(function () {
  document.addEventListener(
    "click",
    function (e) {
      if (e.isTrusted) return;
      var alvo = e.target;
      if (!alvo || alvo.nodeType !== 1 || !alvo.classList.contains("swatch-element")) return;
      if (!alvo.closest(".variants-popup-content")) return;
      var cartao = alvo.closest(".card");
      if (!cartao) return;
      var esteClique = e;
      var limpeza;
      var parar = function (ev) {
        // só age no mesmo clique que pendurou este ouvinte (revisão do Codex, volta 1)
        if (ev !== esteClique) return;
        clearTimeout(limpeza);
        cartao.removeEventListener("click", parar);
        ev.stopPropagation();
      };
      cartao.addEventListener("click", parar);
      // se o clique não chegar ao cartão, o ouvinte sai sozinho logo depois
      // (se chegar, a limpeza é cancelada acima; revisão do Gemini, 17/10/2026)
      limpeza = setTimeout(function () {
        cartao.removeEventListener("click", parar);
      }, 0);
    },
    true
  );
})();
